import { Box } from "@outschool/backpack";
import { Search } from "@outschool/business-rules";
import { useTranslation } from "@outschool/localization";
import { dayjs, formatDate, formatWeekday } from "@outschool/time";
import { ToggleButton } from "@outschool/ui-legacy-component-library";
import { isEqual } from "lodash";
import React from "react";

import { SearchFilters } from "../../../shared/generated/graphql";
import { useTimeZone } from "../../providers/TimeZoneProvider";
import { useParentDashboardFilters } from "./ParentDashboardFilters";

function DateCell({
  title,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  subtitle = null,
  currentFilters,
  filters,
  setFilters,
  trackingSharedProperties = {}
}: {
  title: string;
  subtitle?: string;
  currentFilters: SearchFilters;
  filters: SearchFilters;
  setFilters: (f: SearchFilters) => void;
  trackingSharedProperties?: Record<string, any>;
}) {
  const selected = isEqual(filters, currentFilters);
  return (
    <Box
      sx={{
        width: "80px",
        height: "60px",
        marginRight: "8px"
      }}
    >
      <ToggleButton
        aria-pressed={selected}
        enabled={selected}
        style={{
          borderRadius: "10px",
          padding: "0.5rem",
          lineHeight: "20px",
          height: "60px",
          width: "80px",
          whiteSpace: "normal"
        }}
        onClick={() => setFilters(filters)}
        trackingName="parent_mobile_dashboard_date_picker"
        trackingUniqueId={`${title}-${subtitle}`}
        trackingSharedProperties={trackingSharedProperties}
      >
        <Box>{title}</Box>
        {subtitle && (
          <Box
            sx={{
              fontWeight: "fontWeightRegular"
            }}
          >
            {subtitle}
          </Box>
        )}
      </ToggleButton>
    </Box>
  );
}

export default function DatePicker() {
  const { t } = useTranslation(
    "client\\components\\parentDashboard\\DatePicker"
  );
  const { timeZone } = useTimeZone();
  const { dateFilters, setDateFilters } = useParentDashboardFilters();

  return (
    <Box
      flex
      sx={{
        paddingLeft: "24px",
        overflowX: "auto",
        scrollbarWidth: "none",
        "::-webkit-scrollbar": {
          display: "none"
        }
      }}
    >
      <DateCell
        title={t("This Week")}
        filters={{
          startBefore: Search.RelativeDateFilter.SevenDays,
          startAfter: Search.RelativeDateFilter.SevenDays
        }}
        currentFilters={dateFilters}
        setFilters={setDateFilters}
      />
      {new Array(10).fill(0).map((_, i) => {
        const date = dayjs().tz(timeZone).startOf("day").add(i, "days");
        return (
          <DateCell
            key={date.toISOString()}
            title={formatWeekday(date, timeZone)}
            subtitle={formatDate(date, timeZone)}
            currentFilters={dateFilters}
            filters={{
              startBefore: Search.formatSearchFiltersDate(date),
              startAfter: Search.formatSearchFiltersDate(date)
            }}
            setFilters={setDateFilters}
            trackingSharedProperties={{
              date: date.toISOString(),
              offset: i,
              dayOfWeek: date.day()
            }}
          />
        );
      })}
      <DateCell
        title={t("All Dates")}
        filters={{}}
        currentFilters={dateFilters}
        setFilters={setDateFilters}
      />
    </Box>
  );
}
